import { Reveal } from "./motion/Reveal";

export const SectionHeader = ({ chapter, overline, title, description, align = "left" }) => (
    <div className={`mb-14 lg:mb-20 ${align === "center" ? "text-center" : ""}`}>
        <Reveal>
            <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
                {chapter && (
                    <span className="font-display text-xs tracking-[0.3em] text-[#a2a59d]/60">
                        {chapter}
                    </span>
                )}
                <span className="h-px w-10 bg-[#f6c422]/60" aria-hidden="true" />
                <span className="overline-text">{overline}</span>
            </div>
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-white uppercase mt-5 leading-[1.08]">
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.2}>
                <p className={`text-[#a2a59d] text-base leading-relaxed mt-6 max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
                    {description}
                </p>
            </Reveal>
        )}
    </div>
);
